import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: import.meta.env.VITE_QUERY_RETRY,
      throwOnError: false,
      refetchOnWindowFocus: true,
    },
    mutations: {
      retry: import.meta.env.VITE_QUERY_RETRY,
      throwOnError: false,
    },
  },
});
